import { render } from "./Icon-title-subtitle.vue?vue&type=template&id=61ab6853&scoped=true"
import script from "./Icon-title-subtitle.vue?vue&type=script&lang=js"
export * from "./Icon-title-subtitle.vue?vue&type=script&lang=js"

import "./Icon-title-subtitle.vue?vue&type=style&index=0&id=61ab6853&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ab6853"]])

export default __exports__